export class BaseModel {

    constructor() {

    }

    map(input: any): this
    {
        Object.assign(this, input);
        return this;
    }

}
